export default class numberHelper {

	// Permet de convertir un string en nombre.
	// Si le string est vide/null/undefined cela retourne undefined
	static convertToNumberOrUndefined(valueString: string): number | undefined {
		if (valueString.trim() === "") {
			return undefined;
		}

		const numericValue = Number(valueString);
		return isNaN(numericValue) ? undefined : numericValue;

	}
}



// WEBPACK FOOTER //
// ./src/Helper/numberHelper.ts